/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { ViewStateAttribute } from './view-state-attribute';

export class ViewStateAttributeProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ViewStateAttributeProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsViewStateAttributeProto(
    bb: flatbuffers.ByteBuffer,
    obj?: ViewStateAttributeProto,
  ): ViewStateAttributeProto {
    return (obj || new ViewStateAttributeProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsViewStateAttributeProto(
    bb: flatbuffers.ByteBuffer,
    obj?: ViewStateAttributeProto,
  ): ViewStateAttributeProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ViewStateAttributeProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  attributeType(): ViewStateAttribute {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ViewStateAttribute.NONE;
  }

  attribute<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startViewStateAttributeProto(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addAttributeType(builder: flatbuffers.Builder, attributeType: ViewStateAttribute) {
    builder.addFieldInt8(0, attributeType, ViewStateAttribute.NONE);
  }

  static addAttribute(builder: flatbuffers.Builder, attributeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, attributeOffset, 0);
  }

  static endViewStateAttributeProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createViewStateAttributeProto(
    builder: flatbuffers.Builder,
    attributeType: ViewStateAttribute,
    attributeOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ViewStateAttributeProto.startViewStateAttributeProto(builder);
    ViewStateAttributeProto.addAttributeType(builder, attributeType);
    ViewStateAttributeProto.addAttribute(builder, attributeOffset);
    return ViewStateAttributeProto.endViewStateAttributeProto(builder);
  }
}
